import { render, staticRenderFns } from "./QuestionMultipleAnswer.vue?vue&type=template&id=63a93cdc&scoped=true&"
import script from "./QuestionMultipleAnswer.vue?vue&type=script&lang=js&"
export * from "./QuestionMultipleAnswer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a93cdc",
  null
  
)

export default component.exports